import type { Session } from "@supabase/supabase-js";
import * as React from "react";
import { getSupabase } from "./supabase";

export type SessionState =
  | { status: "loading"; session: null }
  | { status: "signedOut"; session: null }
  | { status: "signedIn"; session: Session };

/** The Supabase session, kept current through onAuthStateChange. */
export function useSession(): SessionState {
  const [state, setState] = React.useState<SessionState>({ status: "loading", session: null });
  React.useEffect(() => {
    const auth = getSupabase().auth;
    let alive = true;
    const apply = (session: Session | null) => {
      if (!alive) return;
      setState(session ? { status: "signedIn", session } : { status: "signedOut", session: null });
    };
    void auth.getSession().then(({ data }) => apply(data.session));
    const { data } = auth.onAuthStateChange((_event, session) => apply(session));
    return () => {
      alive = false;
      data.subscription.unsubscribe();
    };
  }, []);
  return state;
}
